'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _Icon = require('../../../icon/jsx/Icon');

var _Icon2 = _interopRequireDefault(_Icon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; } // React component based on pp-vx design
// https://github.paypal.com/pages/PayPal-UI-R/VX/#dropdowns


function Dropdown(props) {
  var className = props.className,
      error = props.error,
      helper = props.helper,
      leftIcon = props.leftIcon,
      rightIcon = props.rightIcon,
      id = props.id,
      isValid = props.isValid,
      label = props.label,
      name = props.name,
      options = props.options,
      placeholder = props.placeholder,
      value = props.value,
      rest = _objectWithoutProperties(props, ['className', 'error', 'helper', 'leftIcon', 'rightIcon', 'id', 'isValid', 'label', 'name', 'options', 'placeholder', 'value']);

  var baseClass = 'ppvx_dropdown';

  var wrapperClassNames = (0, _classnames2.default)(className, baseClass, _defineProperty({
    'ppvx_field--error': !isValid
  }, baseClass + '--nolabel', !label));

  return _react2.default.createElement(
    'div',
    { className: wrapperClassNames },
    leftIcon && _react2.default.createElement(_Icon2.default, {
      className: baseClass + '__icon--left',
      name: leftIcon.name,
      size: 'xs',
      title: leftIcon.title
    }),
    rightIcon && _react2.default.createElement(_Icon2.default, {
      className: baseClass + '__icon--right',
      name: rightIcon.name,
      size: 'xs',
      title: rightIcon.title
    }),
    _react2.default.createElement(
      'select',
      _extends({
        className: baseClass + '__control',
        id: id,
        defaultValue: value,
        name: name
      }, rest),
      placeholder && _react2.default.createElement(
        'option',
        { disabled: '', value: '', hidden: true },
        placeholder.text
      ),
      options.map(function (option) {
        return _react2.default.createElement(
          'option',
          { key: option.value, value: option.value },
          option.label.text
        );
      })
    ),
    label && _react2.default.createElement(
      'label',
      { htmlFor: id, className: baseClass + '__label' },
      label.text
    ),
    !isValid && error ? _react2.default.createElement(
      'div',
      { className: baseClass + '__error-text' },
      error.text
    ) : helper && _react2.default.createElement(
      'div',
      { className: baseClass + '__helper-text' },
      helper.text
    )
  );
}

Dropdown.propTypes = {
  className: _propTypes2.default.string,
  error: _propTypes2.default.shape({
    text: _propTypes2.default.string.isRequired
  }),
  helper: _propTypes2.default.shape({
    text: _propTypes2.default.string.isRequired
  }),
  leftIcon: _propTypes2.default.shape({
    name: _propTypes2.default.string.isRequired,
    title: _propTypes2.default.string.isRequired
  }),
  rightIcon: _propTypes2.default.shape({
    name: _propTypes2.default.string.isRequired,
    title: _propTypes2.default.string.isRequired
  }),
  id: _propTypes2.default.string.isRequired,
  isValid: _propTypes2.default.bool,
  label: _propTypes2.default.shape({
    text: _propTypes2.default.string.isRequired
  }),
  name: _propTypes2.default.string.isRequired,
  options: _propTypes2.default.arrayOf(_propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number, _propTypes2.default.shape({
    label: _propTypes2.default.shape({
      text: _propTypes2.default.oneOf([_propTypes2.default.string.isRequired, _propTypes2.default.number.isRequired])
    }).isRequired,
    value: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number] // could be an array index
    ).isRequired
  })]).isRequired).isRequired,
  placeholder: _propTypes2.default.shape({
    text: _propTypes2.default.string.isRequired
  }),
  value: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number] // could be an array index
  )
};

Dropdown.defaultProps = {
  className: '',
  error: {
    text: 'Please select one' // overrides helper text when isValid is false
  },
  helper: {
    text: 'Please select an option' // helper text that appears below the field
  },
  leftIcon: {
    name: 'ppvx_icon-heart',
    title: 'Favorite'
  },
  rightIcon: {
    name: 'ppvx_icon-heart',
    title: 'Favorite'
  },
  isValid: true, // must be false for error message to show
  label: {
    text: 'Select your favorite type of food'
  },
  placeholder: {
    text: '<Select one>'
  },
  value: ''
};

exports.default = Dropdown;


//////////////////
// WEBPACK FOOTER
// /donatenodeweb-ci-2793/workspace/donate-gro-release/~/marketing-components/dist/components/atoms/forms/dropdown/jsx/Dropdown.js
// module id = 1063
// module chunks = 4